import React from 'react';
import ReactDOM from 'react-dom/client';
import Initialize from './Initialize';

ReactDOM.createRoot(document.getElementById('root')!).render(<Initialize />);
